export const SAVASSI = '000019';
export const BATEL = '000072';
export const CASA_FARM = '000192';
